import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { NgxPermissionsGuard } from 'ngx-permissions';
import { routeConfig } from '@core/configs/route.config';

// components
import { HomeComponent } from './home/home.component';
import { NotfoundComponent } from '@shared/components/notfound/notfound.component';
import { InitComponent } from './init/init.component';
import { PaymentResultComponent } from './payment-result/payment-result.component';
import { UnauthorizedComponent } from '@app/shared/components/unauthorized/unauthorized.component';
import { CryptoVoucherResultComponent } from './payment-result/crypto-voucher/crypto-voucher.component';
import { TestComponent } from './test/test.component';
import { PreInitComponent } from './pre-init/pre-init.component';
import { PayByLinkResultComponent } from './payment-result/pay-by-link/pay-by-link.component';
import { PblRedirectComponent } from './pbl-redirect/pbl-redirect.component';
import { PixResultComponent } from './payment-result/pix/pix.component';
import { PecFlashResultComponent } from './payment-result/pec-flash/pec-flash.component';
import { BankTransferResultComponent } from './payment-result/bank-transfer/bank-transfer.component';
import { CommunityBankInitializeComponent } from './community-bank/community-bank-initialize.component';
import { SelectAmountComponent } from './community-bank/select-amount/select-amount.component';
import { SelectBankComponent } from './community-bank/select-bank/select-bank.component';
import { NotSuitableToIframeComponent } from '@app/shared/components/not-suitable-to-iframe/not-suitable-to-iframe.component';
import { WaitingResultComponent } from './payment-result/waiting/waiting.component';
import { CryptoCustodyComponent } from './custody-crypto/custody-crypto.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: 'init-payment',
    component: InitComponent,
  },
  {
    path: 'pbl/:id',
    component: PblRedirectComponent,
  },
  {
    path: 'community-bank-init-payment',
    component: CommunityBankInitializeComponent,
    data: {
      routeConfig: 'community-bank-initialize',
      permissions: routeConfig['community-bank-initialize'].permissions,
    },
  },
  {
    path: 'community-banks',
    component: SelectBankComponent,
    data: {
      routeConfig: 'community-bank-initialize',
      permissions: routeConfig['community-bank-initialize'].permissions,
    },
  },
  {
    path: 'community-banks/:swiftCode',
    component: SelectAmountComponent,
    data: {
      routeConfig: 'community-bank-initialize',
      permissions: routeConfig['community-bank-initialize'].permissions,
    },
  },
  {
    path: 'pre-init-payment',
    component: PreInitComponent,
  },
  {
    path: 'payment-result',
    component: PaymentResultComponent,
    canActivate: [NgxPermissionsGuard],
    data: {
      routeConfig: 'payment-result',
      permissions: routeConfig['payment-result'].permissions,
    },
  },
  {
    path: 'payment-result/crypto-voucher',
    component: CryptoVoucherResultComponent,
    canActivate: [NgxPermissionsGuard],
    data: {
      routeConfig: 'payment-result',
      permissions: routeConfig['payment-result'].permissions,
    },
  },
  {
    path: 'payment-result/pay-by-link',
    component: PayByLinkResultComponent,
    canActivate: [NgxPermissionsGuard],
    data: {
      routeConfig: 'payment-result',
      permissions: routeConfig['payment-result'].permissions,
    },
  },
  {
    path: 'payment-result/pix',
    component: PixResultComponent,
    canActivate: [NgxPermissionsGuard],
    data: {
      routeConfig: 'payment-result',
      permissions: routeConfig['payment-result'].permissions,
    },
  },
  {
    path: 'payment-result/pec-flash',
    component: PecFlashResultComponent,
    canActivate: [NgxPermissionsGuard],
    data: {
      routeConfig: 'payment-result',
      permissions: routeConfig['payment-result'].permissions,
    },
  },
  {
    path: 'payment-result/bank-transfer',
    component: BankTransferResultComponent,
    canActivate: [NgxPermissionsGuard],
    data: {
      routeConfig: 'payment-result',
      permissions: routeConfig['payment-result'].permissions,
    },
  },
  {
    path: 'payment-result/waiting',
    component: WaitingResultComponent,
    canActivate: [NgxPermissionsGuard],
    data: {
      routeConfig: 'payment-result',
      permissions: routeConfig['payment-result'].permissions,
    },
  },
  {
    path: '404',
    component: NotfoundComponent,
    data: {
      routeConfig: '404',
    },
  },
  {
    path: 'test',
    component: TestComponent,
  },
  {
    path: '401',
    component: UnauthorizedComponent,
    data: {
      routeConfig: '401',
    },
  },
  {
    path: 'iframe-notfound',
    component: NotSuitableToIframeComponent,
    data: {
      routeConfig: 'iframe-notfound',
    },
  },
  {
    path: 'custody-crypto-payment',
    component: CryptoCustodyComponent,
    canActivate: [NgxPermissionsGuard],
    data: {
      routeConfig: 'custody-crypto-payment',
      permissions: routeConfig['custody-crypto-payment'].permissions,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RoutingModule {}
